import React from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";

const ContactCard = (props) => {
  const { name, title, company, imgsrc } = props;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        // margin: "1rem 2rem 1rem 0",
        padding: "10px",
      }}
      className="contact-card"
    >
      <Box
        component="img"
        src={imgsrc}
        sx={
          {
            // width: "80px",
            // height: "80px",
            // marginRight: "10px",
          }
        }
      ></Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box component={"div"}>
          <Typography
            variant="subtitle2"
            className="name "
            sx={{ fontWeight: "400", textAlign: "center" }}
          >
            {name}
          </Typography>
          <Typography
            variant="subtitle2"
            className="title "
            sx={{ fontWeight: "400", margin: 0 }}
          >
            {title}
          </Typography>
        </Box>
        <Box component={"div"}>
          <Typography
            variant="subtitle2"
            className="title "
            sx={{ fontWeight: "300" }}
          >
            {company}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactCard;
